import { combineReducers } from 'redux';
import { reducer as app } from './app/reducer';
import settingsReducer from './settings/reducer';
import { reducer as home } from './home/reducer';
import { reducer as cooperatives } from './cooperatives/reducer';
import { reducer as lots } from './lots/reducer';
import { reducer as buildings } from './buildings/reducer';
import { reducer as consumption } from './consumption/reducer';
import { reducer as services } from './services/reducer';
import { reducer as bankAccounts } from './bank-accounts/reducer';
import { reducer as eventsInformation } from './events-information/reducer';
import { reducer as fiscalYears } from './fiscal-years/reducer';

import { reducer as todo } from './todo/reducer';
import { reducer as investorBankAccounts } from './investor-bank-accounts/reducer';
import { reducer as widgets } from './widgets/slicer';
import { reducer as notifications } from './notifications/slicer';
import { reducer as personInformation } from './person-information/slicer';
import budgetComparisonReducer from 'slices/budget-comparison-slice';

import { baseApi } from 'shared/api/baseApi';
import meterReadingReducer from 'pages/meter-reading/slice';
import documentsReducer from 'pages/documents/slice';
import purchaseInvoicesReducer from 'features/purchase-invoices/slice';
import keyOrdersReducer from 'pages/key-orders/slice';
import massMessagesReducer from 'pages/mass-messages/slice';
import spaceRenovationRequestsReducer from 'pages/space-renovation/slice';
import userCommonCasesReducer from 'pages/incident/slice';
import userSpaceRenovationRequestsReducer from 'pages/repair/slice';
import eventsListReducer from 'pages/events-list/slice';
import { cooperativeCommonCasesSlice } from 'pages/common-cases';
import { newsLettersSlice } from 'pages/newsletters';

import { searchSlice } from 'features/search/by-technical-subjects';

export const rootReducer = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  app,
  settings: settingsReducer,
  home,
  cooperatives,
  lots,
  buildings,
  consumption,
  services,
  bankAccounts,
  eventsInformation,
  fiscalYears,
  purchaseInvoices: purchaseInvoicesReducer,
  todo,
  massMessages: massMessagesReducer,
  eventsList: eventsListReducer,
  investorBankAccounts,
  widgets,
  notifications,
  personInformation,
  budgetComparison: budgetComparisonReducer,
  meterReading: meterReadingReducer,
  documents: documentsReducer,
  keyOrders: keyOrdersReducer,
  cooperativeSpaceRenovationRequests: spaceRenovationRequestsReducer,
  [cooperativeCommonCasesSlice.name]: cooperativeCommonCasesSlice.reducer,
  userCommonCases: userCommonCasesReducer,
  userSpaceRenovationRequests: userSpaceRenovationRequestsReducer,
  [newsLettersSlice.name]: newsLettersSlice.reducer,
  [searchSlice.name]: searchSlice.reducer,
});
